import { Suspense, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import ToolContainer from './components/wizard/ToolContainer';
import {NavigationContext} from './context/NavigationContext';
import {ThemeProvider} from '@emotion/react';
import config from './config';
import arrayMutators from 'final-form-arrays';
import createDecorator from 'final-form-calculate';
import showPensionIncome from 'shared/helpers/showPensionIncome';
import {finalFormLoadingDecorator as loadingDecorator, FormManager} from '@dnhb/node_package';
import {ToolLoader} from 'shared/components';
import analytics from 'shared/utility/analytics';
import { BrowserRouter } from "react-router-dom";

const decorator = createDecorator(
  loadingDecorator({
    field: 'applicant_dob',
    updates: {
      applicant_showPension: async (value) => {
        const {data} = await showPensionIncome('hypotheekbespaarcheck', value);
        return data?.aow_within_ten_years;
      },
    },
  }),
  loadingDecorator({
    field: 'partner_dob',
    updates: {
      partner_showPension: async (value) => {
        const {data} = await showPensionIncome('hypotheekbespaarcheck', value);
        return data?.aow_within_ten_years;
      },
    },
  }),
);

const App = () => {
  const {
    flow,
    currentStep,
    leadFormActive,
    setLeadFormShowSucces,
    updateStepIndex,
    currentStepIndex,
    recalculatingFromIndex,
    setRecalculatingFromIndex,
    onResultPage,
    onFinalResultPage,
  } = useContext(NavigationContext);
  const [results, setResults] = useState([]);
  const leadFormRequest = onResultPage && leadFormActive;

  const [settings, setSettings] = useState({});
  const [initializing, setInitializing] = useState(true);
  const [broken, setBroken] = useState(false);

  const FormPart = currentStep.component;

  useEffect(() => {
    axios.get(`/${config.app}/tool-settings`)
      .catch(err => console.error(err))
      .then(res => {
        const newSettings = res.data;
        setSettings(newSettings);
        analytics.init('G-KL725KXTE6', newSettings.uaCode);
        setInitializing(false);
      })
  }, [])

  if (initializing) return <ToolLoader/>
  const url = leadFormRequest
    ? `/hypotheekbespaarcheck/lead${onFinalResultPage ? '-advanced' : '-basic'}`
    : `/hypotheekbespaarcheck/calculate/${recalculatingFromIndex ? flow[recalculatingFromIndex - 1].url : currentStep.url}`;

  return (
    <BrowserRouter>
      <FormManager
        url={url}
        initialValues={config.initialFormData}
        onSuccess={response => {
          if (leadFormRequest) {
            setLeadFormShowSucces(true);
          } else {
            if (typeof response.data === 'object') setResults(response.data)
            if (recalculatingFromIndex) {
              updateStepIndex(recalculatingFromIndex);
              setRecalculatingFromIndex(null);
            } else {
              updateStepIndex(currentStepIndex + 1);
            }
          }
        }}
        onError={() => setBroken(true)}
        mutators={{...arrayMutators, setError: (args, state) => (state.formState.errors = args[0])}}
        render={props => {
          return (
            <ThemeProvider theme={settings}>
              <ToolContainer
                {...props}
                settings={settings}
                broken={broken}
              >
                <Suspense fallback={null}>
                  <FormPart {...props} settings={settings}/>
                </Suspense>
              </ToolContainer>
            </ThemeProvider>
          );
        }}
        decorators={[decorator]}
        results={results}
      />
    </BrowserRouter>
  );
};

export default App;
